import { useCallback, useState } from 'react';
import TemplateResponseFieldRenderer from '../TemplateResponseFieldRenderer';
import ClozeParagraphReadOnly from '../ClozeParagraphReadOnly';
import { WordBank } from '../WordBank';
import { useWordBank } from '../DragAndDrop';
import style from './style.scss';

/**
 * Renders a cloze paragraph text input block.
 *
 * The input fields here are using a little hack with css to allow them to automatically grow to the size of the text.
 *
 * The data-value attribute is used to set the size of the input field to the size of the text that has been input
 * It uses an :after pseudo element to set the content of the input field to the value of the data-value attribute
 * The initial value of the data-value attribute is set to 10 spaces, which is the default size of the input field
 */
/* eslint-disable react/prop-types */ // TODO: add props

const InputField = ({ index, value, onChange, readOnly }) => {
  return (
    <span className={style.autoSizer} data-value={value || '          '}>
      <input
        className={style.inputField}
        size="1"
        key={index}
        type="text"
        name={index}
        defaultValue={value}
        autoComplete="off"
        onChange={(e) => onChange(index, e.currentTarget.value)}
        disabled={readOnly}
      />
    </span>
  );
};

export const ClozeParagraphText = ({
  blockData,
  blockResponse = {},
  onResponseChange,
  readOnly,
}) => {
  const { text, options } = blockData;
  const { response_values: responseValues } = blockResponse;
  const { usedOptionIndices } = useWordBank(options, responseValues);
  const [inputFieldValues, setInputFieldValues] = useState(
    responseValues || []
  );

  const responseValueChangeHandler = useCallback(
    (index, value) => {
      if (readOnly) {
        return;
      }

      const newResponseValues = [...(responseValues || [])];
      newResponseValues[index] = value;

      setInputFieldValues(newResponseValues);
      onResponseChange({ response_values: newResponseValues });
    },
    [responseValues, onResponseChange, readOnly]
  );

  if (readOnly) {
    return (
      <ClozeParagraphReadOnly text={text} responseValues={responseValues} />
    );
  }

  return (
    <>
      <WordBank words={options} usedIndices={usedOptionIndices} />
      <p>
        <TemplateResponseFieldRenderer
          text={text}
          renderResponseField={(responseFieldIndex) => (
            <InputField
              index={responseFieldIndex}
              value={
                inputFieldValues ? inputFieldValues[responseFieldIndex] : ''
              }
              onChange={responseValueChangeHandler}
              readOnly={readOnly}
            />
          )}
        />
      </p>
    </>
  );
};
